
import { supabase } from "@/integrations/supabase/client";

export async function deleteProcurement(procurementId: string) {
  console.log(`[DELETE] Attempting to delete procurement: ${procurementId}`);

  // Delete related records first due to foreign key constraints
  const { error: auditError } = await supabase
    .from('procurement_audit')
    .delete()
    .eq('procurement_id', procurementId);

  if (auditError) {
    console.error('[DELETE] Error deleting audit records:', auditError);
    throw new Error(`Failed to delete audit records: ${auditError.message}`);
  }

  const { error: warehouseError } = await supabase
    .from('procurement_warehouse')
    .delete()
    .eq('procurement_id', procurementId);

  if (warehouseError) {
    console.error('[DELETE] Error deleting warehouse records:', warehouseError);
    throw new Error(`Failed to delete warehouse records: ${warehouseError.message}`);
  }

  const { error: financeError } = await supabase
    .from('procurement_finance')
    .delete()
    .eq('procurement_id', procurementId);

  if (financeError) {
    console.error('[DELETE] Error deleting finance records:', financeError);
    throw new Error(`Failed to delete finance records: ${financeError.message}`);
  }

  const { error: qualityError } = await supabase
    .from('procurement_quality')
    .delete()
    .eq('procurement_id', procurementId);

  if (qualityError) {
    console.error('[DELETE] Error deleting quality records:', qualityError);
    throw new Error(`Failed to delete quality records: ${qualityError.message}`);
  }

  const { error: costsError } = await supabase
    .from('procurement_costs')
    .delete()
    .eq('procurement_id', procurementId);

  if (costsError) {
    console.error('[DELETE] Error deleting costs records:', costsError);
    throw new Error(`Failed to delete costs records: ${costsError.message}`);
  }

  const { error: itemsError } = await supabase
    .from('procurement_items')
    .delete()
    .eq('procurement_id', procurementId);

  if (itemsError) {
    console.error('[DELETE] Error deleting items records:', itemsError);
    throw new Error(`Failed to delete items records: ${itemsError.message}`);
  }

  // Finally delete the main procurement record
  const { error: procurementError } = await supabase
    .from('procurements')
    .delete()
    .eq('id', procurementId);

  if (procurementError) {
    console.error('[DELETE] Error deleting procurement:', procurementError);
    throw new Error(`Failed to delete procurement: ${procurementError.message}`);
  }

  console.log(`[DELETE] Successfully deleted procurement: ${procurementId}`);
  return { success: true };
}
